import React, { useMemo } from "react";

export const MAP_H = 44.79; // map aspect 1815/813 → viewBox height for width 100
const COLORS = ["#00F0FF", "#FF007F", "#FFE600", "#39FF14", "#B44DFF"];

export function routeGeom(a, b) {
  const x1 = a.x, y1 = (a.y / 100) * MAP_H, x2 = b.x, y2 = (b.y / 100) * MAP_H;
  const d = Math.hypot(x2 - x1, y2 - y1);
  return { x1, y1, cx: (x1 + x2) / 2, cy: (y1 + y2) / 2 - d * 0.22, x2, y2 };
}

export function bezier(g, t) {
  const u = 1 - t;
  return {
    x: u * u * g.x1 + 2 * u * t * g.cx + t * t * g.x2,
    y: u * u * g.y1 + 2 * u * t * g.cy + t * t * g.y2,
    dx: 2 * u * (g.cx - g.x1) + 2 * t * (g.x2 - g.cx),
    dy: 2 * u * (g.cy - g.y1) + 2 * t * (g.y2 - g.cy),
  };
}

const pathOf = (g) => `M${g.x1},${g.y1} Q${g.cx},${g.cy} ${g.x2},${g.y2}`;

export function TourAmbience({ locations, airport }) {
  const sparkles = useMemo(() => Array.from({ length: 46 }).map((_, i) => ({
    id: i, x: Math.random() * 100, y: Math.random() * 100, s: 1.5 + Math.random() * 2.5,
    c: COLORS[i % COLORS.length], d: Math.random() * 6, t: 2.5 + Math.random() * 4,
  })), []);
  const open = !!airport?.unlocked;
  const routes = airport ? (locations || []).filter((l) => !l.daily)
    .map((l, i) => ({ id: l.id, d: pathOf(routeGeom(airport, l)), i })) : [];

  return (
    <div className="absolute inset-0 pointer-events-none" aria-hidden="true" data-testid="tour-ambience">
      {sparkles.map((p) => (
        <span key={p.id} className="tour-sparkle absolute rounded-full"
              style={{ left: `${p.x}%`, top: `${p.y}%`, width: p.s, height: p.s, background: p.c, boxShadow: `0 0 ${p.s * 3}px ${p.c}`,
                       animationDelay: `${p.d}s`, animationDuration: `${p.t}s` }} />
      ))}
      <svg viewBox={`0 0 100 ${MAP_H}`} preserveAspectRatio="none" className="absolute inset-0 w-full h-full" data-testid="tour-routes" data-open={open ? "true" : "false"}>
        {routes.map((r) => (
          <g key={r.id}>
            <path d={r.d} fill="none" stroke={open ? "#00F0FF" : "#A89BCC"} strokeOpacity={open ? 0.4 : 0.14} strokeWidth="1.4"
                  vectorEffect="non-scaling-stroke" strokeDasharray="5 7" className={open ? "tour-route" : ""} style={{ animationDelay: `${r.i * 0.4}s` }} />
            {open && (
              <circle r="0.4" fill="#FFE600" style={{ filter: "drop-shadow(0 0 1px #FFE600)" }}>
                <animateMotion dur={`${6 + r.i * 1.3}s`} repeatCount="indefinite" path={r.d} begin={`${r.i * 0.9}s`} />
              </circle>
            )}
          </g>
        ))}
      </svg>
    </div>
  );
}
